<div class="upsell-product-box p-4">
  <div class="upsell-product-box__container max-w-container justify-center mx-auto w-full">

    @if (productBoxTitle) {
      <h2 class="upsell-product-box__title desktop:-mx-1 text-2xl text-center bg-dmp-blue text-white font-light uppercase p-4 desktop:py-8 desktop:px-12 text-balance" [innerHTML]="productBoxTitle"></h2>
    }
    <div class="upsell-product-box__wrapper">

      <div class="upsell-product-box__content desktop:-mx-1 flex flex-col items-stretch desktop:flex-row">

        <div class="upsell-product-box__image-wrapper bg-dmp-cream basis-1/2 p-4 flex flex-col justify-center items-center desktop:flex-shrink-0">
          <img class="upsell-product-box__image self-center" [src]="image" alt="{{ imageAlt }}">
        </div>

        <div class="upsell-product-box__description flex items-center justify-center text-center bg-dmp-cream basis-1/2 p-4">
          <div class="mx-auto flex flex-col gap-4">
            @if (productBoxSubtitle) {
              <p class="upsell-product-box__subtitle font-bold uppercase m-0" [innerHTML]="productBoxSubtitle"></p>
            }

            <div class="upsell-product-box__pricing flex flex-col gap-4">
              <div class="h-px bg-dmp-green"></div>
              <div class="upsell-product-box__savings flex flex-col gap-2">
                <p class="upsell-product-box__regularPrice text-2xl font-bold m-0">
                  <span class="upsell-product-box__regularPrice-text">{{regularText}}: </span>
                  <span class="upsell-product-box__regularPrice-number">{{ regularPrice | dynamicCurrency:currency }}</span>
                </p>

                <p class="upsell-product-box__instantSavings text-2xl font-bold text-dmp-gold m-0">
                  <span class="upsell-product-box__instantSavings-text">{{instantSavingsText}}: </span>
                  <span class="upsell-product-box__instantSavings-number">{{ instantSavings | dynamicCurrency:currency }}</span>
                </p>
              </div>
              <div class="h-px bg-dmp-green"></div>

              <p class="upsell-product-box__yourPrice text-3xl font-extrabold m-0">
                <span class="upsell-product-box__yourPrice-text">{{yourPriceText}}: </span>
                <span class="upsell-product-box__yourPrice-number">{{ yourPrice | dynamicCurrency:currency }} {{ currency !== 'USD' ? currency : '' }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (productBoxCTA) {
      <upsell-buttons [buttonYesText]="buttonYesText" [buttonNoText]="buttonNoText" (eventEmitter)="nextPage($event)"></upsell-buttons>
    }
  </div>
</div>
